import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { ROUTES } from 'configs/routes';

/**
 * Хук для определения, нужно ли применять класс для растягивания страницы по высоте
 * Применяется на страницах детального просмотра проектов и странице "О нас"
 */
export const useDetailHeight = (): boolean => {
  const location = useLocation();

  return useMemo(() => {
    const detailPaths = [ROUTES.lk.projects.detail.path, ROUTES.lk.about.path];

    return detailPaths.some((path) => {
      return matchPath({ path }, location.pathname);
    });
  }, [location.pathname]);
};
